import type { Action } from "svelte/action";
import { on } from "svelte/events";

const OPTIONAL_SUFFIX = " (optional)";
const OPTIONAL_SUFFIX_REGEX = /\s*\(optional\)$/;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useOptionalLabelUpdater = (options: {
  /*                                                          */
  host: () => HTMLElement;
  /*                                                           */
  isRequired: () => boolean;
  /*                                                                     */
  hasOptional: () => boolean;
  /*                                                                         */
  withoutOptional: () => boolean;
  /*                                                                                     */
  isValidNode?: (node: ChildNode) => boolean;
}): [
    /**
 *
 *
 */
    action: Action,
    /**
 *
 *
 */
    updater: () => void,
  ] => {
  /*                                                                        */
  const originalLabelTexts = new WeakMap<ChildNode, string>();
  /*                                                                            */
  const isValidNode = options.isValidNode ?? (() => true);

  const shouldShowOptional = $derived(
    !options.isRequired() && options.hasOptional() && !options.withoutOptional(),
  );

  /*                                                                                            */
  const optionalLabelUpdater = () => {
    Array.from(options.host().childNodes).forEach((node) => {
      /*                                                                                       */
      if (!isValidNode(node)) return;

      /*                                                               */
      const currentText = node.textContent;
      if (!currentText) return;


      /*                                                      */
      /*                                             */
      let baseText = originalLabelTexts.get(node);
      if (!baseText) {
        baseText = currentText.replace(OPTIONAL_SUFFIX_REGEX, "");
        originalLabelTexts.set(node, baseText);
      }

      /*                                   */
      const nextText = shouldShowOptional ? `${baseText}${OPTIONAL_SUFFIX}` : baseText;

      /*                   */
      /*                                                                                */
      /*                                                                               */
      if (nextText !== currentText) node.textContent = nextText;
    });
  };

  /*                                    */
  $effect(optionalLabelUpdater);

  /*                                                                      */
  return [
    (node) => {
      const destroy = on(node, "slotchange", optionalLabelUpdater);
      return { destroy };
    },
    optionalLabelUpdater,
  ];
};
